<template>
	<div>
		<block-panel
			:componentType="componentType"
			:query="query"
			:permissionName="permissionName"
			:title="title"
			:defaultPadding="defaultPadding"
		>
			<template v-slot:header>
				<headerTitle :title="title" v-bind="$attrs" v-on="$listeners">
					<template v-slot:headerRight>
						<slot name="headerRight"></slot>
					</template>
				</headerTitle>
			</template>
		</block-panel>
	</div>
</template>
<script>
import headerTitle from '@/components/client/clientModule/headerTitle';
import blockPanel from '@/components/client/clientModule/blockPanel';
export default {
	props: {
		title: {
			type: String,
		},
		componentType: null,
		query: null,
		permissionName: null,
		defaultPadding: {
			type: Boolean,
		},
	},
	components: {
		headerTitle,
		blockPanel,
	},
};
</script>
<style lang="scss" scoped></style>
